import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { ParticipantDTO } from '@/models/ParticipantDTO';
import LocalityAutoComplete from '@/components/inputs/LocalityAutoComplete/LocalityAutoComplete';
import InputText from '../inputs/InputText/InputText';
import InputDate from '../inputs/InputDate/InputDate';
import ParticipantService from '@/services/participant.service';
import { WatchOptions } from 'vue';
import ApiError from '@/exceptions/api.error';

@Component({
  components: {
    LocalityAutoComplete,
    InputText,
    InputDate,
  },
})
export default class ParticipantAdministrative extends Vue {
  @Prop() public value!: ParticipantDTO;
  @Prop({ default: false }) public updating?: boolean;
  public error: boolean = false;
  private errorMessage?: string = undefined;
  private participant: ParticipantDTO = {} as ParticipantDTO;

  public onValideChange() {
    const updatedValue = JSON.parse(JSON.stringify(this.participant));
    ParticipantService.updateAdministrativeInfo(updatedValue)
      .then((x: any) => {
        this.$emit('input', updatedValue);
        this.$emit('updating', false);
      })
      .catch((error: ApiError) => {
        this.error = true;
        switch (error.status) {
          case (500):
            this.errorMessage = this.$i18n.t('errorMgs.serverError').toString();
            break;
          case (401):
            if (error.message === 'incorrectSu') {
              this.errorMessage = this.$i18n.t('errorMgs.adminstrativeIncorrectSuOnSave').toString();
            } else {
              this.errorMessage = this.$i18n.t('errorMgs.sessionExpiration').toString();
            }
            break;
          case (404):
            this.errorMessage = this.$i18n.t('errorMgs.participantNotFound').toString();
            this.errorMessage += ' ';
            this.errorMessage += this.$i18n.t('errorMgs.failedSave').toString();
            break;
          default:
            this.errorMessage = error.message;
        }
      });
  }
  public onCancel() {
    this.participant = JSON.parse(JSON.stringify(this.value));
    this.error = false;
    this.$emit('updating', false);
  }

  @Watch('value', { deep: true } as WatchOptions)
  protected onValueChanged(value: ParticipantDTO, oldValue: ParticipantDTO) {
    if (oldValue !== value) {
      this.participant = JSON.parse(JSON.stringify(this.value));
    }
  }
}
